export const pharmacyProfileActions = {
  FETCH_PHARMACY: {
    REQUEST: 'profile/fetchPharmacyRequest',
    SUCCESS: 'profile/fetchPharmacySuccess',
    FAILURE: 'profile/fetchPharmacyFailure'
  },
  UPDATE_PHARMACY: {
    REQUEST: 'profile/updatePharmacyRequest',
    SUCCESS: 'profile/updatePharmacySuccess',
    FAILURE: 'profile/updatePharmacyFailure'
  },
  COMPLETE_PHARMACY: {
    REQUEST: 'profile/completePharmacyRequest',
    SUCCESS: 'profile/completePharmacySuccess',
    FAILURE: 'profile/completePharmacyFailure'
  }
};
